<script setup>
  import { computed } from 'vue';
  import DataContainer from "@/components/DataContainer.vue";
  import CurrentConditionsGauge from "@/components/CurrentConditionsGauge.vue";

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    spotDataObject: {
      type: Object,
      required: true
    }
  });

  const upgrade = computed(() => props.upgrade);
</script>

<template>
  <DataContainer class="jwx-complete-report-gauge">
    <CurrentConditionsGauge :upgrade="upgrade" :spotDataObject="props.spotDataObject" />
  </DataContainer>
</template>